import { render, staticRenderFns } from "./AssignmentFilters.vue?vue&type=template&id=3cb85db1&scoped=true"
import script from "./AssignmentFilters.vue?vue&type=script&lang=js"
export * from "./AssignmentFilters.vue?vue&type=script&lang=js"
import style0 from "./AssignmentFilters.vue?vue&type=style&index=0&id=3cb85db1&prod&lang=css"
import style1 from "./AssignmentFilters.vue?vue&type=style&index=1&id=3cb85db1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb85db1",
  null
  
)

export default component.exports